import { defineComponent as c, computed as s, openBlock as d, createBlock as r, resolveDynamicComponent as i, normalizeStyle as u, normalizeClass as p, withCtx as y, renderSlot as f, createElementVNode as m, toDisplayString as h } from "vue";
const C = { class: "table-cell-text" }, g = /* @__PURE__ */ c({
  __name: "BaseTableCell",
  props: {
    type: { default: "body" },
    content: { default: "" },
    align: { default: "left" },
    width: { default: "auto" }
  },
  setup(e) {
    const l = e, n = s(() => {
      const t = ["table-cell", `table-cell-${l.type}`], a = `text-${l.align}`;
      return t.push(a), t.join(" ");
    }), o = s(() => ({
      width: l.width
    }));
    return (t, a) => (d(), r(i(e.type === "header" ? "th" : "td"), {
      class: p(n.value),
      style: u(o.value),
      "data-type": e.type
    }, {
      default: y(() => [
        f(t.$slots, "default", {}, () => [
          m("span", C, h(e.content), 1)
        ])
      ]),
      _: 3
    }, 8, ["class", "style", "data-type"]));
  }
});
export {
  g as default
};
